<template>
<div>
  <md-field :class="validationClass">
    <label for="pin">Validation pin</label>
    <md-input type="tel" name="pin" id="pin" v-model="form.pin" :disabled="sending"></md-input>
    <span class="md-error" v-if="!$v.form.pin.required">Validation pin required</span>
    <span class="md-error" v-else-if="!$v.form.pin.numeric">Invalid pin</span>
  </md-field>
  <md-progress-bar md-mode="indeterminate" v-if="sending" />
  <md-card-actions>
    <md-button type="submit" class="md-primary" :disabled="sending" @click="validateAndSend">Send</md-button>
  </md-card-actions>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { validationMixin } from 'vuelidate'
import {
  required,
  numeric,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'

export default {
 mixins: [validationMixin],
  data() {
    return {
      form: {
        pin: null
      }
    }
  },

  validations: {
    form: {
      pin: {
        required,
	numeric,
	minLength: minLength(6),
	maxLength: maxLength(6)
      },
    }
  },

  computed: {
    ...mapState([
      'sending',
      'notification',
      'showNotification',
      'pin'
    ]),
    validationClass() {
      var field = this.$v.form.pin
      return { 'md-invalid': field.$invalid && field.$dirty }
    }
  },

  methods: {
    ...mapActions(['checkPasswordPin']),
    
    async validateAndSend() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
	await this.checkPasswordPin(this.form.pin)
      }
    }
  }
}

</script>
